import { membershipAsMemberQueryKeys } from "@gymflow/api";
import { CancellationDatesDTO, CurrentSubscriptionDTO } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import { FormSelectInput } from "apps/portal/src/components/atoms";
import { useClubSettings } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import { CancelMembershipFormValues } from "../types";

export type FormCancelDateAsMemberSelectProps = {
  activeMembership: CurrentSubscriptionDTO;
};

export const FormCancelDateAsMemberSelect = ({
  activeMembership,
}: FormCancelDateAsMemberSelectProps) => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { club } = useClubSettings();

  return (
    <FormSelectInput<CancelMembershipFormValues, string>
      name="date"
      label={t("page.hostedPagesProfileCancelMembership.form.date")}
      isMulti={false}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: membershipAsMemberQueryKeys.calculateCancelDates({
            membershipId: activeMembership.id,
          }),
          queryFn: async () =>
            (
              await api.customerMembershipApi.calculateCancelDates({
                membershipId: activeMembership.id,
              })
            ).data,
          select: (data) => {
            const { pageParams, pages } =
              data as InfiniteData<CancellationDatesDTO>;
            const transformedPages = pages.map(({ cancellationDateList }) =>
              cancellationDateList.map((item, index) => ({
                id: `${item}-${index}`,
                label: DateTime.fromISO(item)
                  .setZone(club.timezone)
                  .toLocaleString(DateTime.DATE_MED),
                value: item,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          getNextPageParam: () => undefined,
          initialPageParam: undefined,
        })
      }
    />
  );
};
